import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 路由切换时把滚动位置重置到页面顶部。
 * 使用 behavior: 'instant' 避免受全局 smooth scroll 影响产生动画滚动。
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}
